'use client';

import React from 'react';
import DataTable from 'react-data-table-component';
import CustomPagination from './CustomPagination';

const ReusableTable = ({
  columns,
  data,
  title,
  currentPage,
  totalPages,
  totalOrders,
  onChangePage
}) => {
  const rowsPerPage = 10;

  // ✅ Correct Si No logic
  const updatedColumns = columns.map(col => {
    if (col.name === "Si No") {
      return {
        ...col,
        cell: (row, index) =>
          totalOrders - ((currentPage - 1) * rowsPerPage + index)
      };
    }
    return col;
  });

  return (
    <div className="mt-4">
      <h3>{title}</h3>

      <DataTable
        columns={updatedColumns}
        data={data}
        highlightOnHover
        responsive
        pagination
        paginationPerPage={rowsPerPage}
        paginationComponent={(props) => (
          <CustomPagination
            {...props}
            currentPage={currentPage}
            totalPages={totalPages}
            onChangePage={onChangePage}
          />
        )}
      />
    </div>
  );
};

export default ReusableTable;
